"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetConfig = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const starknet_1 = require("./starknet");
const transaction_1 = require("./transaction");
__exportStar(require("./starknet"), exports);
__exportStar(require("./transaction"), exports);
/** Root component that manages the state of all starknet-react hooks. */
function StarknetConfig({ children, ...config }) {
    return ((0, jsx_runtime_1.jsx)(starknet_1.StarknetProvider, { ...config, children: (0, jsx_runtime_1.jsx)(transaction_1.TransactionManagerProvider, { children: children }) }));
}
exports.StarknetConfig = StarknetConfig;
//# sourceMappingURL=index.js.map